// src/components/Question.js
import React, { useState, useEffect } from "react";

import "./style.css";

import AnswerButtons from "../AnswerButtons";
import SupportInfo from "../SupportInfo";
import GoldenButton from "../GoldenButton";

const Question = ({ themeIndex, theme, questions, handleChangeTheme, answerList, themeTotal }) => {
  const [answers, setAnswers] = useState(
    answerList ? Object.values(answerList) : Array(questions.length).fill(null)
  );
  const [couldHasNext, setCouldHasNext] = useState(false);

  useEffect(() => {
    if (answers) {
      setCouldHasNext(answers.every((value) => value !== null && value >= 0 && value <= 3));
    }
  }, [answers]);

  const handleAnswer = (index, value) => {
    const tempanswers = [...answers];
    tempanswers[index] = value;
    setAnswers(tempanswers);
  };

  const handleChangeQuestion = (next) => {
    handleChangeTheme(next, answers);
  };

  return (
    <div className="question-text-container">
      <SupportInfo className="theme-support" />

      <section className="question-main">
        <div className="theme-header">
          <p className="theme-header-counter">
            {themeIndex + 1}/{themeTotal}
          </p>
          <p className="theme-header-text">{theme}</p>
        </div>

        <section className="question-container">
          {questions.map((question, index) => (
            <div className="question-answer-container" key={index}>
              <div className="question-answer-content">
                <p className="question">{question}</p>
                <AnswerButtons
                  index={index}
                  onAnswer={handleAnswer}
                  selectedValue={answers[index]}
                  key={index}
                />
              </div>
            </div>
          ))}
        </section>
        <section className="question-buttons-container">
          {themeIndex > 0 && (
            <GoldenButton
              onClick={() => handleChangeQuestion(false)}
              containerStyle={{
                width: "100%",
              }}
              buttonStyle={{
                width: "100%",
                padding: "20px 25px",
              }}
              content="ANTERIOR"
            />
          )}

          <GoldenButton
            onClick={() => {
              if (couldHasNext) handleChangeQuestion(true);
            }}
            disabled={!couldHasNext && "disable"}
            containerStyle={{
              width: "100%",
            }}
            buttonStyle={{
              width: "100%",
              padding: themeIndex > 0 ? "20px 25px" : "",
            }}
            content="PRÓXIMO"
          />
        </section>
      </section>
    </div>
  );
};

export default Question;
